export default __webpack_public_path__ + "static/media/pubmed_import.488c0304.mp4";